// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row {\n  cursor: default;\n}\n.row:hover {\n  background-color: #666;\n  color: white;\n}\n.headerRow {\n  background-color: #444;\n  color: white;\n  align-items: center;\n}\n.valCell {\n  text-align: center;\n}\n.selected {\n  cursor: default;\n  background-color: steelblue;\n  color: white;\n  font-weight: bold;\n}\n\n.selected:hover {\n  background-color: brown;\n  color: white;\n  font-weight: bold;\n}\n.headerCell {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
